export default "__VITE_ASSET__997ce877__"